module.exports = __webpack_public_path__ + "static/media/ic_select_bank_myway.0e773fa7.svg";